import { Image } from "react-bootstrap";
import Col from "react-bootstrap/esm/Col";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import "./CustomerLandingPage.css"
import FullLogo from '../../../assets/full_logo.png'
import PrimaryButton from "shared/components/PrimaryButton";
import { Link } from "react-router-dom";
import SecondaryButton from "shared/components/SecondaryButton";
import { useAuth0 } from "@auth0/auth0-react";


export default function CustomerLandingPage() {

  const { loginWithRedirect } = useAuth0();

  return (
    <Container className="d-flex align-items-center fill-screen-landing">
      <Row>
        <Col className="align-self-center" style={{minWidth: 300}}>
          <Image src={FullLogo} fluid />
        </Col>
        <Col className="align-self-center" style={{minWidth: 300}}>
          <h1>Customer Portal</h1>
          <p>
            Log in to manage your account, or create a new account to get started. You can also submit a loan application directly.
          </p>
          <Row className="g-2">
            <Col>
              <PrimaryButton buttonText={'Login'} style={{ width: '100%' }} onClick={() => {
                loginWithRedirect({
                  authorizationParams: {
                    redirect_uri: window.location.hostname + '/active'
                  }
                })
              }}></PrimaryButton>
            </Col>
            <Col>
              <Link to={'/create-account'} style={{ display: 'block' }}>
                <SecondaryButton buttonText={'Create Account'} style={{ width: '100%' }} onClick={() => { }}></SecondaryButton>
              </Link>
            </Col>
            <Col>
              <Link to={'/loan/submit'} style={{ display: 'block' }}>
                <SecondaryButton buttonText={'Submit Loan'} style={{ width: '100%' }} onClick={() => { }}></SecondaryButton>
              </Link>
            </Col>
          </Row>

        </Col>
      </Row>
    </Container>
  );
}
